module.exports = new __parcel__URL__("apply_k_zh-tw.2beee0e3.webp").toString();